export default __webpack_public_path__ + "static/media/RedHatText-Bold.bbaeb0c6.ttf";